import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"20px","white-space":"nowrap"},
  class: "fas fa-info-circle"
}, null, -1)
const _hoisted_2 = { style: {"text-align":"justify"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12 col-lg-6" }
const _hoisted_6 = { class: "col-12 col-lg-6 d-flex flex-column justify-content-center" }
const _hoisted_7 = {
  id: "audiocontainer",
  class: "row justify-content-center",
  style: {"width":"100%"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"20px","white-space":"nowrap"},
  class: "fas fa-volume-up"
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  class: "row justify-content-center",
  style: {"width":"100%"}
}
const _hoisted_11 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImageContainer = _resolveComponent("ImageContainer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h5", null, [
      _hoisted_1,
      _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.See, hear & select")), 1)
    ]),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("messages.Choose word based image displayed")), 1),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_ImageContainer, {
          "image-url": _ctx.learns.imageUrl,
          description: _ctx.learns.imageDescription
        }, null, 8, ["image-url", "description"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: "btn btn-secondary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.playVocab(_ctx.translations[_ctx.displayNumber])))
          }, _hoisted_9)
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.translations, (translation) => {
            return (_openBlock(), _createElementBlock("div", {
              key: translation.fromId,
              class: "col-sm-4 text-center",
              style: {"margin-top":"1%"}
            }, [
              _createElementVNode("button", {
                id: "imageaudio1of3to1",
                onClick: ($event: any) => (_ctx.check(translation)),
                class: "btn btn-primary"
              }, _toDisplayString(translation.toName), 9, _hoisted_11)
            ]))
          }), 128))
        ])
      ])
    ])
  ], 64))
}